import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIUserClaimMembershipDelete, APIUserClaimMembershipPost, APIUserClaimMembershipPut } from '../UserClaimMembership/UserClaimMembership.api';

import { APIUserClaimsGetList, UserClaim } from './UserProfileClaims.api';

const getInheritanceField = (claim: UserClaim) => {
    if (!claim.roleName) {
        return '';
    }
    if (!claim.userGroupName) {
        return claim.roleName;
    }
    return `${claim.roleName} (${claim.userGroupName})`;
};

export const fetchUserProfileClaims = createAsyncThunk(
    'userProfileClaims/fetchUserProfileClaims',
    async (item: { tenantId: string, userId: string }) =>
    {
        const { userId, tenantId } = item;
        const response = await APIUserClaimsGetList({ userId, tenantId });
        return response.data.map(claim => ({
            ...claim,
            ...claim.claim,
            id: `${claim.userGroupId ?? 'no_usergroup'}.${claim.roleId ?? 'no_role'}.${claim.claim.id}`,
            inheritance: getInheritanceField(claim),
        })) || [];
    }
);

export const postUserProfileClaims = createAsyncThunk(
    'userProfileClaims/postUserProfileClaims',
    (item: {
        tenantId: string,
        userId: string,
        claimId: string,
        value: string
    }) => {
        return APIUserClaimMembershipPost(item);
    }
);

export const putUserProfileClaims = createAsyncThunk(
    'userProfileClaims/putUserProfileClaims',
    (item: {
        tenantId: string,
        userId: string,
        claimId: string,
        value: string
    }) => {
        return APIUserClaimMembershipPut(item);
    }
);

export const deleteUserProfileClaims = createAsyncThunk(
    'userProfileClaims/deleteUserProfileClaims',
    (item: {
        tenantId: string,
        userId: string,
        claimId: string
    }) => {
        return APIUserClaimMembershipDelete(item);
    }
);
